export default __webpack_public_path__ + "static/media/dashboard_newbg.d3270ff4.png";